<template>
  <v-btn
    id="saving-button"
    data-cy="save-button"
    v-if="isSaving || state === SaveButtonState.saving"
    :disabled="true"
  >
    {{ displaySavingLabel }}
  </v-btn>

  <v-btn
    id="save-button"
    data-cy="save-button"
    v-else-if="hasRecentlyUpdated && state === SaveButtonState.error"
    variant="outlined"
    rounded
    color="error"
    :disabled="disabled"
  >
    <v-icon left>error</v-icon>
    {{ displayErrorLabel }}
  </v-btn>

  <v-btn
    id="save-button"
    data-cy="save-button"
    v-else-if="hasRecentlyUpdated"
    variant="outlined"
    rounded
    color="primary"
    :disabled="disabled"
  >
    <v-icon left>check</v-icon>
    {{ displaySavedLabel }}
  </v-btn>

  <v-btn
    type="button"
    id="saved-button"
    data-cy="save-button"
    v-else
    rounded
    color="primary"
    @click.stop.prevent="onClick"
    :disabled="disabled"
  >
    {{ displayLabel }}
  </v-btn>
</template>

<script>
    import {SaveButtonState} from "@/components/buttons/SaveButtonState";

    export default {
        name: 'SaveButton',
        computed: {
            SaveButtonState() {
                return SaveButtonState
            },
            displayLabel() {
              return this.label || this.$t('entities.save');
            },
            displaySavedLabel() {
              return this.savedLabel || this.$t('entities.saved');
            },
            displayErrorLabel() {
              return this.errorLabel || this.$t('entities.error');
            },
            displaySavingLabel() {
              return this.savingLabel || this.$t('entities.saving');
            }
        },

        props: {
            disabled: Boolean,

            /**
             * DEPRECATED: Use `state` instead
             */
            isSaving: Boolean,

            /**
             * Do not use `isSaving` and `state` together
             * This is preferred over `isSaving`
             */
            state: {
                type: String,
                validator: function (value) {
                    return Object.values(SaveButtonState).includes(value)
                }
            },

            label: String,
            savedLabel: String,
            errorLabel: String,
            savingLabel: String,
        },

        data() {
            return {
                hasRecentlyUpdated: false,
            }
        },

  watch: {
    isSaving: function (newValue, oldValue) {
      if (oldValue && !newValue) {
        this.hasRecentlyUpdated = true;
        setTimeout(() => (this.hasRecentlyUpdated = false), 3000);
      }
    },
    state: function (newValue) {
      if (
        newValue === SaveButtonState.saved ||
        newValue === SaveButtonState.error
      ) {
        this.hasRecentlyUpdated = true;
        setTimeout(() => (this.hasRecentlyUpdated = false), 3000);
      }
    },
  },

  methods: {
    onClick() {
      this.$emit("save");
    },
  },
};
</script>

<style scoped>
.v-btn {
    border-radius: 14px !important;

    background-color: var(--primary-color);
    color: white;
}
.v-btn--variant-outlined {
  background-color: white !important;
  color: var(--primary-color) !important;
}

#saving-button {
    border-radius: 14px !important;
    box-shadow: none;
}
.v-btn--disabled {
  color: #939393;
  background-color: #efefef;
}
</style>
